import { Component, Input } from '@angular/core';
import { SupportChatService } from '../../services/support-chat.service';
import { Message } from '../../models/message.model';

@Component({
  selector: 'app-popover-chat',
  templateUrl: './popover-chat.component.html',
  styleUrls: ['./popover-chat.component.scss'],
})
export class PopoverChatComponent {
  @Input() hideFeedbackButton: boolean = false;

  constructor(public supportChatService: SupportChatService) {}

  toggleChat() {
    this.supportChatService.isChatVisible =
      !this.supportChatService.isChatVisible;
  }

  sendMessage(message: Message) {
    this.supportChatService.sendMessage(message);
  }
}
